// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".get-app__container[data-v-ab77e5d8]{text-align:right}@media(max-width:1200px){.get-app__container[data-v-ab77e5d8]{flex-grow:1}}.get-app__button[data-v-ab77e5d8]{background:#fb8c00;border-radius:2px;color:#fff;font-size:15px;font-weight:700;text-decoration:none;padding:6px 8px;height:30px;display:inline-block;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
